var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_3746_64052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.66 10.1484C26.945 10.1484 24.515 11.4684 23 13.4934C21.485 11.4684 19.055 10.1484 16.34 10.1484C11.735 10.1484 8 13.8984 8 18.5334C8 20.3184 8.285 21.9684 8.78 23.4984C11.15 30.9984 18.455 35.4834 22.07 36.7134C22.58 36.8934 23.42 36.8934 23.93 36.7134C27.545 35.4834 34.85 30.9984 37.22 23.4984C37.715 21.9684 38 20.3184 38 18.5334C38 13.8984 34.265 10.1484 29.66 10.1484Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8787 11.0138C30.6108 11.0808 30.448 11.3522 30.5149 11.6201C30.5819 11.888 30.8534 12.0509 31.1213 11.9839L30.8787 11.0138ZM36.4 14.6989C35.8832 14.0098 35.0062 13.0027 34.042 12.2122C33.5602 11.8172 33.0396 11.4622 32.5173 11.232C31.9998 11.0039 31.4294 10.8761 30.8787 11.0138L31.1213 11.9839C31.3706 11.9216 31.7002 11.9647 32.114 12.147C32.5229 12.3272 32.9648 12.6222 33.408 12.9855C34.2938 13.7117 35.1168 14.6546 35.6 15.2989L36.4 14.6989Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1213 11.0568C16.3892 11.1237 16.552 11.3952 16.4851 11.6631C16.4181 11.931 16.1466 12.0939 15.8787 12.0269L16.1213 11.0568ZM10.6 14.7418C11.1168 14.0527 11.9938 13.0456 12.958 12.2552C13.4398 11.8602 13.9604 11.5051 14.4827 11.2749C15.0002 11.0469 15.5706 10.9191 16.1213 11.0568L15.8787 12.0269C15.6294 11.9646 15.2998 12.0076 14.886 12.19C14.4771 12.3702 14.0352 12.6652 13.592 13.0285C12.7062 13.7547 11.8832 14.6976 11.4 15.3418L10.6 14.7418Z",
    fill: "#3D3D3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_3746_64052",
    x: 0,
    y: 0.1,
    width: 46,
    height: 48.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.40625
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3746_64052"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3746_64052",
    result: "effect2_dropShadow_3746_64052"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_3746_64052",
    result: "effect3_dropShadow_3746_64052"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_3746_64052",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.e78a9665b7ba9bfe25336afa44863581.svg";
export { ForwardRef as ReactComponent };